var exports = {
  "L": "x43aef4ae--bb269c--source-link",
};

module.exports = exports;
